import { createContext, useState, useEffect, type ReactNode } from 'react'
import { setAccountBlockedHandler } from '../services/api-client'
import { getBlockedMessage } from '../hooks/useMe'
import { captureSessionId, debugDumpAuthState } from '../utils/session'

interface AccountBlockedContextValue {
  blockedError: unknown
  setBlockedError: (error: unknown) => void
}

export const AccountBlockedContext = createContext<AccountBlockedContextValue>({
  blockedError: null,
  setBlockedError: () => {},
})

export function AccountBlockedProvider({ children }: { children: ReactNode }) {
  const [blockedError, setBlockedError] = useState<unknown>(null)

  useEffect(() => {
    setAccountBlockedHandler((error) => {
      const path = window.location.pathname
      if (path === '/auth/logout' || path === '/auth/login' || path === '/auth/error') return
      const message = getBlockedMessage(error)
      console.warn('[auth:AccountBlockedContext] account_blocked — capturing session_id before clearing tokens')
      debugDumpAuthState('AccountBlockedContext before clear')
      captureSessionId()
      sessionStorage.setItem('logout_reason', 'account_blocked')
      sessionStorage.setItem('logout_message', message)
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      debugDumpAuthState('AccountBlockedContext after clear')
      window.location.href = '/auth/error'
    })
    return () => setAccountBlockedHandler(null)
  }, [])

  return (
    <AccountBlockedContext.Provider value={{ blockedError, setBlockedError }}>
      {children}
    </AccountBlockedContext.Provider>
  )
}
